// /dashboard/:orgSlug/billing/success — Figma frame 20 checkout success (33:3431).
// Owner: screens-commerce, US-141. No Stripe anywhere in this run.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { CheckoutSuccessScreen } from "../screens/commerce/CheckoutSuccessScreen";

export const billingSuccessRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/billing/success",
  staticData: { title: "Checkout complete" },
  component: BillingSuccessRoute,
});

function BillingSuccessRoute() {
  const { orgSlug } = billingSuccessRoute.useParams();
  return (
    <CheckoutSuccessScreen orgSlug={orgSlug} />
  );
}
